import { Component, inject } from '@angular/core';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';

interface DeleteDialog {
  title: string,
  message: string,
  buttonSaveText: string;
  buttonCancelText: string;
  isWarningMessage?: boolean,
  endpointsLength?: number
  warningMessage?: string,
  fontWeight?: string,
}

@Component({
  selector: 'app-delete-dialog',
  templateUrl: './delete-dialog.component.html',
  styleUrls: ['./delete-dialog.component.scss'],
  standalone: false
})
export class DeleteDialogComponent {
  public data = inject(NZ_MODAL_DATA) as DeleteDialog;

  constructor(
    private dialogRef: NzModalRef<DeleteDialogComponent>
  ) { }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }
}
